import { PlusIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

import FieldsetContainer from '@/components/shared/FieldsetContainer';
import { Button } from '@/components/ui/daisy';
import useFormList from '@/data/hook/shared/useFormList';
import LessonPlanItem, { LessonPlanItemDTO } from '@/models/LessonPlanItem';

import LessonPlanItemInlineForm from './LessonPlanItemInlineForm';

type LessonPlanItemFormListProps = {
  coursePathId: number;
  courseLineId: number;
  onSubmit: (data: LessonPlanItemDTO) => Promise<LessonPlanItem>;
  isLoading: boolean;
};

export default function LessonPlanItemFormList({
  coursePathId,
  courseLineId,
  onSubmit,
  isLoading,
}: LessonPlanItemFormListProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'courseLineForm.lessonPlansTab',
  });
  const { openForms, addForm, removeForm, handleFormSubmit } =
    useFormList<LessonPlanItemDTO>({ onSubmit });

  return (
    <div className="flex flex-col gap-4">
      {openForms.map(formId => (
        <LessonPlanItemInlineForm
          key={formId}
          coursePathId={coursePathId}
          courseLineId={courseLineId}
          onSubmit={handleFormSubmit(formId)}
          onCancel={() => removeForm(formId)}
          isLoading={isLoading}
        />
      ))}
      <FieldsetContainer>
        <Button color="primary" className="w-full" onClick={addForm}>
          <PlusIcon className="w-4 h-4" />
          {t('addLesson')}
        </Button>
      </FieldsetContainer>
    </div>
  );
}
